var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "vn6v2t4swa"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.725490 0 0 0 0 0.737255 0 0 0 0 0.745098 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#vn6v2t4swa)",
    transform: "translate(-14 -282) translate(-4)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0D191F",
    d: "M10 1.176c4.873 0 8.824 3.95 8.824 8.824 0 4.873-3.95 8.824-8.824 8.824-4.873 0-8.824-3.95-8.824-8.824 0-4.873 3.95-8.824 8.824-8.824zm.941 12H8.824v2.118h2.117v-2.118zm0-8.47H8.824v6.353h2.117V4.706z",
    transform: "translate(18 282)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorsIcon);
export default __webpack_public_path__ + "static/media/errors-icon.7f506b8e711b3506c89c5750a648283e.svg";
export { ForwardRef as ReactComponent };